import { render, staticRenderFns } from "./AiReportInsightsCard.vue?vue&type=template&id=f1d7663a&scoped=true"
import script from "./AiReportInsightsCard.vue?vue&type=script&lang=ts"
export * from "./AiReportInsightsCard.vue?vue&type=script&lang=ts"
import style0 from "./AiReportInsightsCard.vue?vue&type=style&index=0&id=f1d7663a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d7663a",
  null
  
)

export default component.exports